import spinRoute from '../../../router/spinRoute.js';

//管理角色 所有页面
export default [
    {
        path: '/label/queryContainer',
        redirect: '/label/queryEmp',
        component: () => spinRoute.require(import('../queryContainer.vue')),
        children: [
            {
                path: '/label/queryEmp',
                component: () => spinRoute.require(import('../queryEmp.vue')),
                meta: { title: '标签', keepAlive: true },
            },
            {
                path: '/label/searchAdvance',
                component: () => spinRoute.require(import('../pages/searchAdvance.vue')),
                meta: { title: '标签管理' },
            },
            {
                path: '/label/searchResult',
                component: () => spinRoute.require(import('../pages/searchResult.vue')),
                meta: { title: '员工查询' },
            },
            {
                path: '/label/empDetail',
                component: () => spinRoute.require(import('../detail/empDetail.vue')),
                meta: { title: '员工画像' },
            },
        ]
    },
]
